<template>
    <div class="analytics-contact-types-filter">
        <ds-multiselect
            v-if="!hideInput"
            v-model="filter.value"
            searchable
            placeholder="Search contact types"
            bind-value-only
            :options="availableContactTypeOptions"
        />
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        value: Object,
        types: Array,
    },

    data() {
        return {
            filter: this.value,
            allContactTypes: {},
        };
    },

    created() {
        this.fetchAllContactTypes();
    },

    watch: {
        value: {
            handler(value) {
                this.filter = value;
            },
            deep: true,
        },

        filter: {
            handler() {
                this.updateQuery();
            },
            deep: true,
        },

        'filter.modifier': function() {
            this.updateQuery();
        },
    },

    computed: {
        availableContactTypeOptions() {
            const options = [];

            Object.keys(this.allContactTypes).forEach((key) => {
                options.push({ value: key, label: key });
            });

            return options;
        },

        hideInput() {
            return this.filter.modifier === 'isempty' || this.filter.modifier === 'isfilled';
        },
    },

    methods: {
        updateQuery() {
            let query = '';

            switch (this.filter.modifier) {
            case 'equals':
                query = this.filter.value;
                break;
            case 'notequals':
                query = `-${this.filter.value}`;
                break;
            case 'isempty':
                query = 'EMPTY';
                break;
            case 'isfilled':
                query = '-EMPTY';
                break;
            default:
                break;
            }

            this.filter.query = query;
        },

        async fetchAllContactTypes() {
            if (this.allContactTypes.length) {
                return;
            }

            try {
                const { data } = await axios.get('/app/contact/loadDropdowns');

                this.allContactTypes = data.personType;
            } catch (e) {
                this.$error({ message: 'Unable to fetch the contact types' });
            }
        },
    },
};
</script>
